import React from 'react';

import iconRight from '../../../assets/images/chevron-right-solid.svg';
import profile_x3 from '../../../assets/images/menu/profile@3x.png';

export function ExactDriverItem({
  setRideDetailes,
  rideInfo,
  formatAMPM,
  setSelectedRide,
  setStartRequests,
}) {
  return (
    <div
      className="px-4 py-3 w-full flex items-center border-b border-gray-200 cursor-pointer hover:bg-gray-100"
      onClick={() => {
        setSelectedRide(rideInfo);
        setRideDetailes(true);
        setStartRequests(true);
      }}
    >
      <div
        className="bg-white min-w-12 w-12 h-12 rounded-full border mr-3"
        style={{
          backgroundImage: `url(${rideInfo.driver.userImg || profile_x3})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        {' '}
      </div>
      <div className="w-9/12 flex flex-col justify-between mr-3">
        <div className="w-full flex justify-between items-center mb-3">
          <div className="relative">
            <span className="text-sm font-bold">{`${rideInfo.driver.firstName} ${rideInfo.driver.lastName}`}</span>
            <span className="absolute -top-3 left-0 text-xs text-purple-400">Eco</span>
          </div>
          <div className="text-sm">
            <span className="mr-2 font-bold text-nuale_turquoise">MUR</span>
            <span className="font-bold text-nuale_turquoise">
              {rideInfo && rideInfo.pricePerSeat.toFixed(2)}
            </span>
          </div>
        </div>
        <div className="w-full flex text-xs text-gray-600">
          <div className="mr-4">
            <span>Pickup : </span>
            <span className="font-bold">{formatAMPM(new Date(+rideInfo.waypointsEta[0].eta))}</span>
          </div>
          <div>
            <span>ETA : </span>
            <span className="font-bold">{formatAMPM(new Date(+rideInfo.waypointsEta[1].eta))}</span>
          </div>
        </div>
      </div>
      <button>
        <img src={iconRight} alt="icon forward" className="w-2" />
      </button>
    </div>
  );
}
